// components/uikit/Typography/Typography.tsx
import clsx from 'clsx'
import React from 'react'

export type TypographyType =
  | '7xl-display'
  | '6xl-display'
  | '5xl-display'
  | '4xl-display'
  | '3xl-heading'
  | '2xl-heading'
  | 'xl-heading'
  | 'l-strong'
  | 'm-strong'
  | 's-strong'
  | '2xs-strong'
  | 'xs-midi'
  | 's-midi'
  | 'm-body'
  | 's-body'

interface Props<T extends React.ElementType> {
  tag?: T
  type?: TypographyType | undefined
  className?: string
  color?: string
  children: React.ReactNode
}

const typeStyles: Record<TypographyType, string> = {
  '7xl-display': 'text-7xl leading-[80px] font-bold',
  '6xl-display': 'text-[56px]',
  '5xl-display': 'text-[48px] leading-[56px] font-bold',
  '4xl-display': 'text-[40px] leading-[48px] font-bold',
  '3xl-heading': 'text-[32px] leading-[40px] font-semibold',
  '2xl-heading': 'text-[24px] leading-[32px] font-semibold',
  'xl-heading': 'text-[20px] leading-[28px] font-semibold',

  'l-strong': 'text-lg font-semibold',
  'm-strong': 'text-base font-semibold',
  's-strong': 'text-sm font-semibold',
  '2xs-strong': 'text-[10px] font-semibold',

  'xs-midi': 'text-xs font-medium',
  's-midi': 'text-sm font-medium',

  'm-body': 'text-base font-normal',
  's-body': 'text-sm font-normal',
}

export const Typography = <T extends React.ElementType = 'p'>({
  tag,
  type = 'm-body',
  className,
  color,
  children,
}: Props<T>) => {
  const Component = tag || 'p'

  return (
    <Component className={clsx(typeStyles[type], className)} style={color ? { color } : undefined}>
      {children}
    </Component>
  )
}
